import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHamster = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 411,
	height: 359,
	viewBox: "0 0 411 359",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_718_1370)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M209.19 358.3C298.936 358.3 371.69 285.546 371.69 195.8C371.69 106.054 298.936 33.3 209.19 33.3C119.444 33.3 46.6899 106.054 46.6899 195.8C46.6899 285.546 119.444 358.3 209.19 358.3Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M314.42 303.5H249.99C249.16 303.5 248.49 302.83 248.49 302C248.49 301.17 249.16 300.5 249.99 300.5H314.42C315.25 300.5 315.92 301.17 315.92 302C315.92 302.83 315.25 303.5 314.42 303.5Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M241.96 303.5H60.73C59.9 303.5 59.23 302.83 59.23 302C59.23 301.17 59.9 300.5 60.73 300.5H241.97C242.8 300.5 243.47 301.17 243.47 302C243.47 302.83 242.8 303.5 241.97 303.5H241.96Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.3601C87.7401 290.69 82.3501 285.3 82.3501 278.68V62.46C82.3501 55.84 87.7401 50.45 94.3601 50.45H260.34",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.36C87.74 290.69 82.35 285.3 82.35 278.68V62.46C82.35 55.84 87.74 50.45 94.36 50.45H260.34M260.33 37.63H94.35C80.64 37.63 69.52 48.75 69.52 62.46V278.68C69.52 292.39 80.64 303.51 94.35 303.51H260.33C274.04 303.51 285.16 292.39 285.16 278.68V62.46C285.16 48.75 274.04 37.63 260.33 37.63Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 0.310001C187.69 0.310001 196.31 8.93 196.31 19.55V30.24H157.83V19.55C157.83 8.93 166.45 0.310001 177.07 0.310001Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 24.5C180.958 24.5 184.11 21.3481 184.11 17.46C184.11 13.5719 180.958 10.42 177.07 10.42C173.182 10.42 170.03 13.5719 170.03 17.46C170.03 21.3481 173.182 24.5 177.07 24.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_718_1370",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 119,
				y: 25,
				width: 116,
				height: 40,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_718_1370)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M241.63 55.98H112.51V68.12H241.63V55.98Z",
					fill: "#FFB100"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M335.95 139.12C335.97 139.62 335.78 140.12 335.43 140.47L322.82 153.09C322.5 153.41 322.09 153.63 321.65 153.67C321.11 153.71 320.6 153.53 320.23 153.15L314.8 147.72C314.44 147.36 314.25 146.87 314.28 146.37C314.3 145.87 314.54 145.39 314.93 145.07C315.63 144.49 316.71 144.56 317.38 145.23L321.47 149.32C321.47 149.32 321.52 149.34 321.53 149.32L332.87 137.98C333.54 137.31 334.61 137.24 335.32 137.82C335.71 138.14 335.94 138.62 335.97 139.12H335.95Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 125.66C139.845 125.66 147.68 117.825 147.68 108.16C147.68 98.495 139.845 90.66 130.18 90.66C120.515 90.66 112.68 98.495 112.68 108.16C112.68 117.825 120.515 125.66 130.18 125.66Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 100.46H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 116.94H228.01",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 191.1C139.845 191.1 147.68 183.265 147.68 173.6C147.68 163.935 139.845 156.1 130.18 156.1C120.515 156.1 112.68 163.935 112.68 173.6C112.68 183.265 120.515 191.1 130.18 191.1Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 165.89H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 182.38H210.64",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 256.54C139.845 256.54 147.68 248.705 147.68 239.04C147.68 229.375 139.845 221.54 130.18 221.54C120.515 221.54 112.68 229.375 112.68 239.04C112.68 248.705 120.515 256.54 130.18 256.54Z",
				fill: "#3F8BFD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 231.33H192.76",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 247.82H228.01",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 109.32L128.38 113.68L137.55 104.51",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 174.3L128.38 178.65L137.55 169.48",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 240.23L128.38 244.58L137.55 235.41",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.6899 169.29C21.7099 169.79 21.5199 170.29 21.1699 170.64L8.55993 183.26C8.23993 183.58 7.82993 183.8 7.38993 183.84C6.84993 183.88 6.33993 183.7 5.96993 183.32L0.53993 177.89C0.17993 177.53 -0.0100701 177.04 0.0199299 176.54C0.0399299 176.04 0.27993 175.56 0.66993 175.24C1.36993 174.66 2.44993 174.73 3.11993 175.4L7.20993 179.49C7.20993 179.49 7.25993 179.51 7.26993 179.49L18.6099 168.15C19.2799 167.48 20.3499 167.41 21.0599 167.99C21.4499 168.31 21.6799 168.79 21.7099 169.29H21.6899Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M278.97 1.7C278.99 2.2 278.8 2.7 278.45 3.05L265.84 15.67C265.52 15.99 265.11 16.21 264.67 16.25C264.13 16.29 263.62 16.11 263.25 15.73L257.82 10.3C257.46 9.94 257.27 9.45 257.3 8.95C257.32 8.45 257.56 7.97 257.95 7.65C258.65 7.07 259.73 7.14 260.4 7.81L264.49 11.9C264.49 11.9 264.54 11.92 264.55 11.9L275.89 0.559999C276.56 -0.110001 277.63 -0.180001 278.34 0.399999C278.73 0.719999 278.96 1.2 278.99 1.7H278.97Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M410.35 95.27C410.39 96.04 410.09 96.8 409.55 97.35L390.17 116.73C389.68 117.22 389.05 117.56 388.37 117.62C387.55 117.69 386.76 117.4 386.19 116.82L377.84 108.47C377.29 107.92 377 107.16 377.04 106.39C377.08 105.62 377.44 104.89 378.04 104.4C379.12 103.51 380.77 103.61 381.8 104.64L388.09 110.93C388.09 110.93 388.16 110.96 388.19 110.93L405.61 93.51C406.64 92.48 408.28 92.38 409.37 93.27C409.97 93.77 410.33 94.49 410.37 95.27H410.35Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M228.84 296.76C228.84 288.52 235.53 281.84 243.76 281.84H250.63V294.47C250.63 299.46 246.58 303.51 241.59 303.51H235.57C231.85 303.51 228.83 300.49 228.83 296.77L228.84 296.76Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M298.43 294.47V281.84H305.3C313.54 281.84 320.22 288.53 320.22 296.76C320.22 300.48 317.2 303.5 313.48 303.5H307.46C302.47 303.5 298.42 299.45 298.42 294.46L298.43 294.47Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M273.94 189.18H275.11C305.78 189.18 330.68 214.08 330.68 244.75V255.1C330.68 281.82 308.99 303.51 282.27 303.51H266.77C240.05 303.51 218.36 281.82 218.36 255.1V244.75C218.36 214.08 243.26 189.18 273.93 189.18H273.94Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M274.53 276.12C299.289 276.12 319.36 246.969 319.36 211.01C319.36 175.051 299.289 145.9 274.53 145.9C249.771 145.9 229.7 175.051 229.7 211.01C229.7 246.969 249.771 276.12 274.53 276.12Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M241.349 141.544C247.464 140.3 253.443 144.257 254.687 150.372L259.292 173.008C247.063 175.496 235.116 167.589 232.628 155.36L232.532 154.889C231.288 148.775 235.246 142.796 241.361 141.552L241.349 141.544Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M289.768 173.018L294.374 150.382C295.618 144.267 301.597 140.31 307.711 141.554C313.826 142.798 317.784 148.777 316.539 154.892L316.444 155.362C313.956 167.592 302.009 175.499 289.78 173.01L289.768 173.018Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M256.17 183.03C258.932 183.03 261.17 180.791 261.17 178.03C261.17 175.269 258.932 173.03 256.17 173.03C253.409 173.03 251.17 175.269 251.17 178.03C251.17 180.791 253.409 183.03 256.17 183.03Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M292.88 183.03C295.642 183.03 297.88 180.791 297.88 178.03C297.88 175.269 295.642 173.03 292.88 173.03C290.119 173.03 287.88 175.269 287.88 178.03C287.88 180.791 290.119 183.03 292.88 183.03Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M274.53 165.19C278.06 165.19 280.93 168.06 280.93 171.59V188.78H268.12V171.59C268.12 168.06 270.99 165.19 274.52 165.19H274.53Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M294.92 187.63H254.14C246.9 187.63 241.03 193.5 241.03 200.74C241.03 207.98 246.9 213.85 254.14 213.85H294.92C302.16 213.85 308.03 207.98 308.03 200.74C308.03 193.5 302.16 187.63 294.92 187.63Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M251.75 200.14H297.29V264.71C297.29 277.28 287.09 287.48 274.52 287.48C261.95 287.48 251.75 277.28 251.75 264.71V200.14Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M276.79 187.63H272.26C270.051 187.63 268.26 189.421 268.26 191.63C268.26 193.839 270.051 195.63 272.26 195.63H276.79C278.999 195.63 280.79 193.839 280.79 191.63C280.79 189.421 278.999 187.63 276.79 187.63Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M274.53 199.09V194.42",
				stroke: "#002F75",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M262.59 199.09C262.59 202.38 265.26 205.06 268.56 205.06C271.86 205.06 274.53 202.39 274.53 199.09",
				stroke: "#002F75",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M274.53 199.09C274.53 202.38 277.2 205.06 280.5 205.06C283.8 205.06 286.47 202.39 286.47 199.09",
				stroke: "#002F75",
				strokeWidth: 3,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_718_1370",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 410.36,
			height: 358.3,
			fill: "white"
		})
	}) })]
});
export default SvgHamster;
